export default function polyIsClockwise(poly) {
  var sum = 0;
  for (var i = 0; i < poly.length - 1; i++) {
    var cur = poly[i],
      next = poly[i + 1];
    sum += (next[0] - cur[0]) * (next[1] + cur[1]);
  }
  return sum > 0;
}
